import { RequireSignedIn } from '@/components/auth/RequireSignedIn'
import { RequireOrganization } from '@/components/organization/RequireOrganization'
import { ROUTES } from '@/constants/routeConstants'
import { createFileRoute, Navigate } from '@tanstack/react-router'

function IndexComponent() {
  return (
    <RequireSignedIn>
      <RequireOrganization>
        <Navigate to={ROUTES.API_KEYS} replace={true} />
      </RequireOrganization>
    </RequireSignedIn>
  )
}

export const Route = createFileRoute('/')({
  component: IndexComponent,
})
